import { Typography } from "@mui/material";

export default () => (
  <div id="logo">
    <Typography variant="h1">
      <span style={{ color: "#fff" }}>B</span> cov
    </Typography>
    <div id="underscore"></div>
  </div>
);
